import Badge, { ColorType } from '@/common/components/Badge'
import { TransactionStatus } from '@/schemas/TransactionStatusSchema'

interface Props {
  value: TransactionStatus
  className?: string
}

function getColor(value: TransactionStatus): ColorType {
  if (value === 'Completed') {
    return 'Positive'
  }

  if (value === 'Refunded by Provider' || value === 'Declined') {
    return 'Negative'
  }

  if (
    value === 'In review' ||
    value === 'Partially Refunded by Provider' ||
    value === 'Partial Refund in Progress'
  ) {
    return 'Notice'
  }

  return 'Neutral'
}

export default function TransactionStatusBadge({ value, className }: Props) {
  return (
    <Badge semanticColor={getColor(value)} className={className}>
      {value}{' '}
    </Badge>
  )
}
